
import React from 'react';
import CommonAreaTable from '../CommonAreaTable';
import CustomCard from '../../../../../components/CustomCard';
import NotInformation from '../../../../../components/NotInformation';
import ScheduleLocationApp from '../Functionality/ScheduleLocationApp';
import BookSpace from '../Modals/BookSpace';
import {
    CleanIcon,
    CloseIcon,
    IconClockTable, IconScheduleTable, InfoChip,
    OutlinedCalendarIcon, TrashOutlineIcon
} from '../../../../../components/buttons/IconButtons';
import { DATE_TIME_FORMAT_NAME_MODEL, getDateFormat } from '../../../../../Apis/functions';
import SectionSelected from '../Components/SectionSelected';
import CustomUserChip from '../../../../../components/CustomUserChip';
import { POSITION_MODEL } from '../../../../../Helpers/PositionModel';
import ButtonIcon from '../../../../../components/buttons/ButtonIcon';
import {Trans} from 'react-i18next';
import CustomTooltip from "../../../../../components/CustomTooltip";

/**
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */
const ScheduleLocation = (
    {
        eventDetail, setEventDetail, handleChange, handleClearSteps
    }
) => {

    const { t,
        setBodyForExport, setSearch, setSimpleSearch,
        results, setResults,
        searchElement, setSearchElement,
        modalBookSpace, setModalBookSpace,
        allFreeReservation, setAllFreeReservation,
        getEventSetting,
        handleClickItem,
        handleSelectSlot,
        handleConfirmSelectSlot
    } = ScheduleLocationApp({ eventDetail, setEventDetail, handleChange });


    const BookingSelected = ({ eventDetail, t }) => {
        return (
            <div className='col-12'>
                <CustomCard
                    classes={"w-100"}
                    classCard={'card-border-8px'}
                    classContent={'background-shades-50'}
                >
                    <div className='d-flex justify-content-between w-100'>
                        <div className='d-flex align-items-start gap-3 w-100'>
                            <div className={`background-primary-100 d-flex align-items-center justify-content-center p-8px maxw-44px border-radius-8px`} >
                                <OutlinedCalendarIcon />
                            </div>
                            <div className='d-flex flex-column align-items-start flex-grow-1'>
                                <div className={"flex-grow-1 minw-0"}>
                                    <CustomTooltip
                                        text={eventDetail?.zoneSelected?.zoneName}
                                        classes={`mb-0 fs-12px ibl-font-w-600 text-ellipsis-1-row`}
                                        showIfTruncated={true}
                                        placement={"top"}
                                    />
                                </div>

                                <div className={"d-flex"}>
                                    <IconScheduleTable className={"mr-8px mb-1 icon-color-shades-800"} />
                                    <p className="fs-14px ibl-font-w-400 font-color-shades-800">{` ${t("from")} ${eventDetail?.bookingSelected?.from.slice(0, 5)} ${t("to").toLowerCase()} ${eventDetail.bookingSelected?.to.slice(0, 5)}`}</p>
                                </div>
                                <p className="ml-28px fs-14px ibl-font-w-400 font-color-shades-800">{getDateFormat(eventDetail?.dateSelected, false, DATE_TIME_FORMAT_NAME_MODEL.shortMonth)}</p>
                                <div className={"d-flex"}>
                                    <IconClockTable className={"mr-8px icon-color-shades-800"} />
                                    <p className="fs-14px ibl-font-w-400 font-color-shades-800">{` ${t("duration")} ${eventDetail?.bookingSelected?.duration} ${t("minutes").toLowerCase()}`}</p>
                                </div>
                            </div>
                        </div>
                        <div className='d-flex justify-content-center align-items-center' >
                            <TrashOutlineIcon
                                className='icon-color-shades-400 icon-hover-shades-950'
                                onClick={() => {
                                    setEventDetail(prev => ({
                                        ...prev,
                                        zoneSelected: null,
                                        dateSelected: null,
                                        bookingSelected: null,
                                    }))
                                }}
                            />
                        </div>
                    </div>
                </CustomCard>
            </div>
        );
    }

    return (
        <>
            {(eventDetail.id === null || eventDetail.id === '') && (
                <div className='col-12 d-flex justify-content-end mb-2'>
                    <ButtonIcon
                        className='btn-clean-secondary-600'
                        id='btn_sl_clean_form'
                        Icon={CleanIcon}
                        title={'clear_instances'}
                        onClick={() => {
                            handleClearSteps();
                        }}
                    />
                </div>
            )}

            { getEventSetting?.bookingWindowEnabled &&
                <div className="mb-3">
                    <CustomUserChip
                        className="m-0 chip-secondary-150-100 w-100 p-0 justify-content-start"
                        name={
                            <Trans
                                i18nKey="booking_opens_value_days_in_advance"
                                values={{ days: getEventSetting?.bookingWindowValue }}
                                components={{
                                    strong: <span className="fs-12px ibl-font-w-700 font-color-secondary-700" />
                                }}
                            />
                        }
                        Icon={InfoChip}
                        showAvatar={true}
                        variant="large"
                        iconPosition={POSITION_MODEL.LEFT}
                        classNameIcon="icon-color-secondary-700"
                        deleteIcon={<CloseIcon fontSize='small' className={`font-color-secondary-700 h-18px`} />}
                    />
                </div>
            }

            <CustomCard classes={"w-100"} classCard={'card-border-8px'}>
                <div className='row'>
                    <div className=' col-sm-12 col-md-8 px-0'>
                        <CommonAreaTable
                            setBodyForExport={setBodyForExport}
                            setSearch={setSearch}
                            setSimpleSearch={setSimpleSearch}
                            results={results}
                            setResults={setResults}
                            searchElement={searchElement}
                            setSearchElement={setSearchElement}
                            handleClickItem={handleClickItem}
                            eventDetail={eventDetail}
                        />
                    </div>
                    <div className='col-sm-12 col-md-4 pr-0'>
                        <SectionSelected>
                            {
                                eventDetail?.bookingSelected != null
                                    ?
                                    <BookingSelected
                                        eventDetail={eventDetail}
                                        t={t}
                                    />
                                    :
                                    <NotInformation text={t('no_time_slots_schedules_added_yet')} className={"h-215px"} card={true} />
                            }
                        </SectionSelected>
                    </div>
                </div>
            </CustomCard>

            {modalBookSpace && (
                <BookSpace
                    show={modalBookSpace}
                    onHide={() => {
                        setEventDetail(prev => ({
                            ...prev,
                            zoneSelected: null,
                            dateSelected: null,
                        }));
                        setAllFreeReservation([]);
                        setModalBookSpace(false);
                    }}
                    onConfirm={() => {
                        handleConfirmSelectSlot();
                    }}
                    allFreeReservation={allFreeReservation}
                    handleChange={handleChange}
                    eventDetail={eventDetail}
                    handleSelectSlot={handleSelectSlot}
                />
            )}
        </>
    )

}

export default ScheduleLocation
